// extracted by mini-css-extract-plugin
export default {"mCard":"Xz-z","image":"Yz-z","imageNoBackground":"Zz-z","imageHasCategory":"_z-z","fullWidth":"aA-z"};